export const colors = {
  primary: '#3B3362',
  secondary: '#FDCA3C'
} as const
